interface IProps {
  condition: boolean;
  wrapper: any;
  children: any;
}

export const ConditionalWrapper = ({ condition, wrapper, children }: IProps) => (condition
  ? wrapper(children)
  : children);
